import { render, staticRenderFns } from "./whdProduct.vue?vue&type=template&id=0d97c8f0&lang=pug&"
import script from "./whdProduct.vue?vue&type=script&lang=js&"
export * from "./whdProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports